import React from 'react';
import { RichText, Image } from '@synergycms_core/components/generic';

export default props => {
  const { classes } = props;
  return (
    <div className={classes.corporateContainer}>
      <Image innerStyle={classes.corporateBox} backgroundImage={'./assets/images/corporate.png'} alt={'Corporate'}>
        <div className={classes.corporateTitle}>
          <div>
            <RichText translate={true} text={'_%un universo de ventajas%_'} ucFirst={true} />
          </div>
        </div>
        <ul className={classes.corporateList}>
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'corportateIconSale'} />
            <RichText translate={true} text={'_%ofertas exclusivas%_'} ucFirst={true} />
          </li>
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'corporateIcon2'} />
            <RichText translate={true} text={'_%corporate en vacaciones%_'} ucFirst={true} />
          </li>
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'corporateIcon3'} />
            <RichText translate={true} text={'_%early checkin%_'} ucFirst={true} />
          </li>
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'corporateIconRestoration'} />
            <RichText translate={true} text={'_%oferta en restauración%_'} ucFirst={true} />
          </li>
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'corporateIcon4'} />
            <RichText translate={true} text={'_%area personal intranet%_'} ucFirst={true} />
          </li>
          <li className={classes.corporateItem}>
            <Image innerStyle={classes.corporateIcon} svg={'corporateIconCheckOut'} />
            <RichText translate={true} text={'_%late checkout%_'} ucFirst={true} />
          </li>
        </ul>
      </Image>
    </div>
  );
};
